/**
 * Полный адрес ящика. Домен приходит с сервера (колонка mailboxes.domain):
 * старые ящики живут на pe4kin.com, новые создаются на актуальном домене.
 * Фоллбэк на pe4kin.com — для старых ответов API без поля domain.
 */
export const LEGACY_EMAIL_DOMAIN = 'pe4kin.com';

export const mailboxDomain = (mailbox?: { domain?: string | null } | null): string =>
  mailbox?.domain || LEGACY_EMAIL_DOMAIN;

export const mailboxAddress = (mailbox: { name: string; domain?: string | null }): string =>
  `${mailbox.name}@${mailboxDomain(mailbox)}`;

export default mailboxAddress;
